import CONSTANTS from 'chat-constants';

export const getUsableChannels = (state) => {
  return state.channels
    .filter(
      (channel) =>
        !channel.deletedAt &&
        CONSTANTS.CHANNEL.PICKABLE_TYPES.includes(channel.type)
    )
    .sort(sortChannelsAlphabetically);
};

function sortChannelsAlphabetically(a, b) {
  const alphanumericA = a.name?.toLowerCase() || '';
  const alphanumericB = b.name?.toLowerCase() || '';
  return alphanumericA.localeCompare(alphanumericB, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}
